import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, ProgressBar, Alert } from "react-bootstrap";
import axios from "axios";

const TrackOrder = () => {
    const { orderId } = useParams();
    const [orderStatus, setOrderStatus] = useState("");
    const [error, setError] = useState(null);

    const statusSteps = ["Pending", "Processing", "Shipped", "Delivered"];

    const getProgress = () => (statusSteps.indexOf(orderStatus) / (statusSteps.length - 1)) * 100;

    useEffect(() => {
        const fetchOrderStatus = async () => {
            try {
                const response = await axios.get(`https://madhusewingmachines.com/api/orders/${orderId}/status`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                });
                setOrderStatus(response.data.status);
            } catch (err) {
                console.error("Error fetching order status:", err);
                setError("Failed to fetch order status.");
            }
        };
        fetchOrderStatus();
    }, [orderId]);

    return (
        <Container className="py-5">
            <h2>Order Tracking</h2>
            {error ? <Alert variant="danger">{error}</Alert> : (
                <>
                    <h4>Status: {orderStatus}</h4>
                    <ProgressBar now={getProgress()} label={`${getProgress()}%`} animated />
                </>
            )}
        </Container>
    );
};

export default TrackOrder;
